
// export const BASE_URL = "http://localhost:3000/";
// export const RESOURCE_BASE_URL = "http://localhost:8080/";
// export const WS_BASE_URL = "http://localhost:8080/api/";
// export const KEYCLOAK_LOGIN_DIRECT_URL = "http://localhost:8180/auth/realms/kitcut-realm/protocol/openid-connect/auth?client_id=kitcut-service&response_mode=fragment&response_type=code&login=true&redirect_uri=http://localhost:3000/";
// export const KEYCLOAK_REGISTRATION_URL = "http://localhost:8180/auth/realms/kitcut-realm/protocol/openid-connect/registrations?client_id=kitcut-service&response_mode=fragment&response_type=code&redirect_uri=http://localhost:3000/";
// export const KEYCLOAK_LOGIN_DIRECT_URL = "http://localhost:8180/auth/realms/kitcut-realm/protocol/openid-connect/auth?client_id=kitcut-service&response_mode=fragment&response_type=code&login=true&redirect_uri=http://localhost:3000/";

// ---------------------------------- LIVE SERVER -----------------------------------------
export const BASE_URL = "https://kitcutlabo.com/";
export const RESOURCE_BASE_URL = "https://kitcutlabo.com/";
export const WS_BASE_URL = "https://kitcutlabo.com/api/";

// -------------------------------- TEST SERVER MAPPED ------------------------------------------
// export const BASE_URL = "https://staging.kitcut.hsenid.lk/";
// export const RESOURCE_BASE_URL = "https://staging.kitcut.hsenid.lk:8080/";
// export const KEYCLOAK_LOGIN_DIRECT_URL = "https://testbed.kitcut.hsenid.lk:8180/auth/realms/kitcut-realm/protocol/openid-connect/auth?client_id=kitcut-service&response_mode=fragment&response_type=code&login=true&redirect_uri=https://testbed.kitcut.hsenid.lk/";
// export const KEYCLOAK_REGISTRATION_URL = "https://testbed.kitcut.hsenid.lk:8180/auth/realms/kitcut-realm/protocol/openid-connect/registrations?client_id=kitcut-service&response_mode=fragment&response_type=code&redirect_uri=https://testbed.kitcut.hsenid.lk/";
//

// -------------------------------- TEST AWS SERVER MAPPED ------------------------------------------
//export const BASE_URL = "https://testbed.kitcut.hsenid.lk/";
//export const RESOURCE_BASE_URL = "https://testbed.kitcut.hsenid.lk/";
//export const WS_BASE_URL = "https://testbed.kitcut.hsenid.lk/api/";
//

export const DEVELOPMENT_MODE = false;

/* Pagination configuration */
export const ITEM_COUNT_PER_PAGE = 5;
export var PAGE_OPEN_TYPE = window.innerWidth < 993 ? "" : "_blank";
export var IS_IN_MOBILE_MODE = window.innerWidth < 993;

export const GOOGLE_ANALYTICS_CODE = "UA-151875767-1";

// stripe test configuration ---------------------------------------------------------------------------------------------
//export const STRIPE_PUBLISHABLE_KEY = "pk_test_pdmDDZPMWZQNPbMFckEJcbAO00ZZtjY1jq"; //hsenid

// stripe live configuration ---------------------------------------------------------------------------------------------
export const STRIPE_PUBLISHABLE_KEY = "pk_live_SH1YI9lXYPMkYuXx9WzGDSSS00EUCTa5h9";

// google calendar configuration ------------------------------------------------------------------------------------
export const GOOGLE_CALENDAR_API_KEY = "AIzaSyAIvKpheP1pSZvO4x1QlcwaARLjK9e_aTQ";

export const EVENT_SOURCES =
    [{
        googleCalendarId: 'kitcutlabo@gmail.com',
        className : 'kitcut-holidays'
    },{
        googleCalendarId: 'ja.japanese#holiday@group.v.calendar.google.com',
        className : 'japan-holidays'
    }];


// paypal configuration------------------------------------------------------------------------------------------------------

// sandbox---------------------------------
// export const PAYPAL_ENV = "sandbox";
// export const PAYPAL_CLIENT_ID = "AY9Nt5-QX4lDsRM25_YqIBYoe7ppT73gIud8-kyItJNxBB2zM4diw5YgoaSa5iCE1xaF4WA3JY6VnfHy";

// live---------------------------------------

export const PAYPAL_ENV = "production";
export const PAYPAL_CLIENT_ID = "ARvCSM9bkVdr8QqFB3b0C_6hxzTE0IQHkeSZUznAzamMo-7kLJh_K_J28f1gVBAQlu6ERZn07u2ytbzK";

// -------------------------------------------------------------------------------------------------------------------------------


// WEBPACK FOOTER //
// ./src/configuration.js